var map = {
	"./animals/elephant.png": 5207,
	"./animals/giraffe.png": 7494,
	"./animals/hippo.png": 7102,
	"./animals/monkey.png": 7491,
	"./animals/panda.png": 4514,
	"./animals/parrot.png": 4188,
	"./animals/penguin.png": 8126,
	"./animals/pig.png": 3022,
	"./animals/rabbit.png": 2404,
	"./animals/snake.png": 4098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7007;